import React, { useEffect } from "react";
import { useState } from "react";
import {
  Menu,
  X,
  ShoppingCart,
  ChevronDown,
  User,
  Package,
  FileText,
  Cloud,
  Settings,
  Key,
  Phone,
  Mail,
  Home,
  ShoppingBag,
  Plane,
  Briefcase,
  Building,
  LogIn,
} from "lucide-react";
import { Link } from "react-router-dom";

// import Hero from "../components/homepage/Hero";
import BuyCertifiedDrone from "../components/homepage/BuyCertifiedDrone";
import OurPartners from "../components/homepage/OurPartners";
import DroneJob from "../components/homepage/DroneJob";
import LatestBlogs from "../components/homepage/LatestBlogs";
import Customer from "../components/homepage/Customer";
//  
import Navbar from "../components/homepage/Navbar";
import GoogleLocation from "../components/common/GoogleLocation";
import { Header, Footer } from "../shared";
import { Helmet } from "react-helmet-async";
import {
  Hero,
  Cards,
  InfoSection,
  MainGrid,
  Services,
} from "../components/homepage/newHomePage";

const HomePage = () => {
  return (
    <>
    <Helmet>
        <title>
          Drone Planet – Best Drone Selling Company and Marketplace in India
        </title>

        <meta
          name="description"
          content="Drone Planet is India's best drone marketplace company to buy and sell drones, drone parts and accessories for DGCA certified pilots and services."
        />

        <link
          rel="canonical"
          href="https://droneplanet.in/"
        />
      </Helmet>
    <div className="bg-slate-50">
      <Header />
      <main className="">
        <Hero />
        {/* <Services /> */}
        <MainGrid />
        {/* <Cards /> */}
        <InfoSection />
        <Footer />
      </main>
      {/* <div className="bg_darkblue">
        <Header />
      </div> */}
      {/* <Hero />
      <BuyCertifiedDrone /> */}
      {/* <OurPartners /> */}
      {/* <DroneJob />
      <LatestBlogs />
      <Customer />*/}
      {/* <Footer /> */}
    </div>
    </>
  );
};

export default HomePage;
